import { useModal } from '@/contexts/ModalContext';
import { Dialog, DialogContent, DialogTitle, DialogHeader } from './ui/dialog';

export function ModalRenderer() {
  const { modals, closeModal } = useModal();

  if (modals.length === 0) return null;
  return (
    <>
      {modals.map((modal) => (
        <Dialog
          key={modal.id}
          open={true}
          onOpenChange={(open) => {
            if (!open) closeModal(modal.id);
          }}
        >
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>{modal.heading}</DialogTitle>
            </DialogHeader>
            <div className="mt-4">{modal.component}</div>
          </DialogContent>
        </Dialog>
      ))}
    </>
  );
}
